module.exports = __webpack_public_path__ + "assets/images/pages/fundivisa/fundivisa-2.png?32857838";